<template lang="pug">
div(class="matdate", :class="{ 'after-16': !$media.xl }")
    div(class="insety-16")
        label(class="bold bond-title fg70") {{ $t('currency') }}
    ib-dropdown(class="inset-8 bondsearch-currency outset-0",
        width="15ch" name="currency" v-model="selected" @change="selectCurrency", :data="avaiCurrencies")
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'CurrencySelector',

        mixins: [ mxGb ],

        props: {
            isMuni: {
                type: Boolean,
                default: false
            }
        },

        data() {
           return {
                selected: '',
                currencies: [
                    { label: this.$t('ALL'), value: '' },
                    { label: 'USD', value: 'USD' },
                    { label: 'CAD', value: 'CAD' },
                    { label: 'EUR', value: 'EUR' },
                    { label: 'GBP', value: 'GBP' }
                ]
           }
        },

        computed: {
            avaiCurrencies() {
                if (this.isMuni) {
                    return this.currencies.filter(e => e.value === 'USD');
                }
                return this.currencies;
            }
        },

        methods: {
            reset() {
                if (this.isMuni) {
                    this.selected = 'USD'; 
                } else { 
                    this.selected = ''; 
                } 
            },
            selectCurrency() {
                this.$emit('currencySelect', this.selected);
            }
        },

        watch: {
            isMuni(val) {
                if (val) {
                    this.selected = 'USD';
                } else {
                    this.reset();
                }
                this.$emit('currencySelect', this.selected);
            },
        },

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    this.selected = this.getFilterValue('currencyLike') || '';
                }
                this.$emit('currencySelect', this.selected);
            });
        }
 }
</script>